import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EmitTecladoService {
    constructor() {
        this.model = new EventEmitter();
        this.dataInput = new EventEmitter();
    }
    enviarModel(model) {
        this.model.emit(model);
    }
    enviarDataInput(dataInput) {
        this.dataInput.emit(dataInput);
    }
}
EmitTecladoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmitTecladoService_Factory() { return new EmitTecladoService(); }, token: EmitTecladoService, providedIn: "root" });
